/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unused-state */
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import { contractTypeKeys, MessageType } from "../../../Constant";
import { settlementUploadSheetAction } from "../../../redux/action-creators/settlementActionCreator";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import { Button } from "../../widgets";
import { GenericLoaderComponent } from "../../widgets/genericLoader";
import { grossContributionUploadSheetAction } from "../../../redux/action-creators/collectionActionCreator";
import { settlementUploadSheetFailure } from "../../../redux/actions/settlementAction";
import "./uploadExcelModal.css";
import { grossContributionUploadSheetFailure } from "../../../redux/actions/collectionAction";
import { uploadExcelFileAction } from "../../../redux/action-creators/distanceReportActionCreator";
import { distanceUploadSheetFailure } from "../../../redux/actions/distanceReportAction";
import { passRevenueUploadExcelFileAction } from "../../../redux/action-creators/passRevenueActionCreator";
import { passRevenueUploadSheetFailure } from "../../../redux/actions/passRevenueAction";
import { expenseUploadExcelFileAction } from "../../../redux/action-creators/expenseActionCreator";
import { expenseUploadSheetFailure } from "../../../redux/actions/expenseAction";
import { ondcReportAction } from "../../../redux/action-creators/ondcReportUploadActionCreator";
import { ondcReportUploadFailure } from "../../../redux/actions/ondcReportUpload";
import _store from "../../../redux/createStore";

const convertDate = (inputFormat) => {
  function pad(s) {
    return s < 10 ? `0${s}` : s;
  }
  const d = new Date(inputFormat);
  return [pad(d.getDate() + 1), pad(d.getMonth() + 1), d.getFullYear()].join(
    "/",
  );
};

const displayDuplicateContractError = (
  duplicateContractErrorStr,
  busNumberTrimmed,
  convertedDate,
  contractType,
  rowNo,
) => {
  // eslint-disable-next-line no-param-reassign
  duplicateContractErrorStr = duplicateContractErrorStr.length
    ? `${duplicateContractErrorStr}
  Row: ${rowNo} - ${busNumberTrimmed},${convertedDate},${contractType}`
    : `You can not add same type of contract twice for a bus for any given day to edit the data. Please refer the details below:
  Row: ${rowNo} - ${busNumberTrimmed},${convertedDate},${contractType}`;
  return duplicateContractErrorStr;
};
class UploadExcelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      fileName: "",
      dataErrorInFile: "",
    };
    this.fileInputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { settlementUploadSheet, messageCallBack, fileLoader } = this.props;
    if (
      settlementUploadSheet.success === true
      && prevProps.settlementUploadSheet !== settlementUploadSheet
    ) {
      messageCallBack(MessageType.SUCCESS, settlementUploadSheet.message);
    }
    if (!fileLoader && fileLoader !== prevProps.fileLoader) {
      messageCallBack(MessageType.ERROR, null);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleSubmission = () => {
    // eslint-disable-next-line no-console
    console.log("submission type not specified");
  };

  handleSheetSubmission = (sheetAction) => {
    const { type, addOnFilter = {} } = sheetAction;
    const { uploadSheetAction } = this.props;
    const store = _store.getState();
    const file = this.fileInputRef.current.files[0];
    const metadata = store?.Auth?.user?.role === "Finance" ? "FINANCE" : "CRUT";
    if (type === "ondcReport") {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("metadata", metadata);
      uploadSheetAction({ file, metadata }, "fileLoader", type);
    } else {
      const formData = new FormData();
      formData.append("files", file);
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (event) => {
        const bufferArray = event.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { raw: false });
        if (Object.keys(addOnFilter).length) {
          uploadSheetAction({ data, addOnFilter }, "fileLoader", type);
        } else {
          uploadSheetAction(data, "fileLoader", type);
        }
      };
    }
  };

  handleBulkGCEditSubmission = () => {
    const formData = new FormData();
    const file = this.fileInputRef.current;

    formData.append("files", file.files[0]);
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file.files[0]);

    fileReader.onload = (event) => {
      this.setState({ dataErrorInFile: "" });
      const bufferArray = event.target.result;
      const wb = XLSX.read(bufferArray, { type: "buffer", cellDates: true });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);
      this.checkGCDataValidity(data);
    };
  };

  handleBusNumberError = (busNumberTrimmed, dataErrorInFile, rowNo) => {
    !busNumberTrimmed?.length
      && this.setState({
        dataErrorInFile: dataErrorInFile.length
          ? `${dataErrorInFile} <br/> Row: ${rowNo} - Invalid Bus Number`
          : `Row: ${rowNo} - Invalid Bus Number`,
      });
  };

  handleAmountError = (amount, dataErrorInFile, rowNo, busNumberTrimmed) => {
    (Number.isNaN(amount) || (!amount && amount !== 0))
      && this.setState({
        dataErrorInFile: dataErrorInFile.length
          ? `${dataErrorInFile} <br/> Row: ${rowNo} - Invalid Amount for Bus Number: ${busNumberTrimmed}`
          : `Row: ${rowNo} - Invalid Amount for Bus Number: ${busNumberTrimmed}`,
      });
  };

  handleContractTypeError = (
    contractType,
    contractTypeKey,
    dataErrorInFile,
    rowNo,
    busNumberTrimmed,
  ) => {
    (!contractType || !contractTypeKey)
      && this.setState({
        dataErrorInFile: dataErrorInFile.length
          ? `${dataErrorInFile} <br/> Row: ${rowNo} - Invalid Contract Type for Bus Number: ${busNumberTrimmed}`
          : `Row: ${rowNo} - Invalid Contract Type for Bus Number: ${busNumberTrimmed}`,
      });
  };

  handleConvertedDateError = (
    convertedDate,
    dataErrorInFile,
    rowNo,
    busNumberTrimmed,
  ) => {
    convertedDate.length !== 10
      && this.setState({
        dataErrorInFile: dataErrorInFile.length
          ? `${dataErrorInFile} <br/> Row: ${rowNo} - Invalid Date for Bus Number: ${busNumberTrimmed}`
          : `Row: ${rowNo} - Invalid Date for Bus Number: ${busNumberTrimmed}`,
      });
  };

  handleDuplicateContractError(duplicateContractErrorStr, dataErrorInFile) {
    if (duplicateContractErrorStr.length !== 0) {
      this.setState({
        dataErrorInFile: dataErrorInFile.length
          ? `${dataErrorInFile} <br/> <br/> ${duplicateContractErrorStr}`
          : duplicateContractErrorStr,
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getAmount(value) {
    return typeof value?.Amount === "number"
      ? Number.parseFloat(value?.Amount?.toFixed(2))
      : Number.parseFloat(value?.Amount);
  }

  // eslint-disable-next-line class-methods-use-this
  getConvertedDate(value) {
    return typeof value.Date === "string" ? value.Date : convertDate(value.Date);
  }

  // eslint-disable-next-line class-methods-use-this
  getDataErrorInFile(dataErrorInFile, rowNo) {
    return dataErrorInFile.length
      ? `${dataErrorInFile} <br/> Row: ${rowNo} - Amount can not be negative`
      : `Row: ${rowNo} - Amount can not be negative`;
  }

  changeHandler = (event) => {
    const url = event.target.files;
    const fileType = url && url[0] && url[0].type;
    const { uploadSheetErrorAction, uploadType } = this.props;

    uploadSheetErrorAction("", uploadType);
    this.setState({ fileName: url && url[0] && url[0].name });

    if (uploadType === "ondcReport") {
      if (fileType !== "text/csv") {
        uploadSheetErrorAction(
          "Invalid file format. Kindly upload only .csv for ONDC Report.",
          uploadType,
        );
        this.fileInputRef.current.value = "";
      }
    } else if (
      fileType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      uploadSheetErrorAction(
        "Invalid file format. Kindly upload only .xlsx.",
        uploadType,
      );
      this.fileInputRef.current.value = "";
    }
  };

  checkGCDataValidity = (data) => {
    const { dataErrorInFile } = this.state;
    const { uploadSheetAction, initiateNotification } = this.props;
    data.length > 200
      && this.setState({ dataErrorInFile: "File contains more than 200 rows" });
    data.length === 0
      && this.setState({
        dataErrorInFile: "The sheet is empty. Please make some valid entries.",
      });
    const busIndexMap = new Map();
    let count = 0;
    let duplicateContractErrorStr = "";
    dataErrorInFile.length === 0
      && Object.entries(data).forEach(([key, value]) => {
        const busNumberTrimmed = value["Bus Number"]?.replace(/\s/g, "");
        const convertedDate = this.getConvertedDate(value);
        const contractType = value["Contract Type"];
        const contractTypeKey = contractTypeKeys[value["Contract Type"]?.toLowerCase()];
        const amount = this.getAmount(value);
        const rowNo = parseInt(key, 10) + 2;
        const mapKey = `${busNumberTrimmed}-${convertedDate}`;
        amount < 0
          && this.setState({
            dataErrorInFile: this.getDataErrorInFile(dataErrorInFile, rowNo),
          });
        if (this.isErrorInFormFields(
          busNumberTrimmed,
          convertedDate,
          contractType,
          contractTypeKey,
          amount,
        )
        ) {
          // Error cases handled individually inside this if block
          this.handleBusNumberError(busNumberTrimmed, dataErrorInFile, rowNo);
          this.handleAmountError(amount, dataErrorInFile, rowNo, busNumberTrimmed);
          this.handleContractTypeError(
            contractType,
            contractTypeKey,
            dataErrorInFile,
            rowNo,
            busNumberTrimmed,
          );
          this.handleConvertedDateError(
            convertedDate,
            dataErrorInFile,
            rowNo,
            busNumberTrimmed,
          );
        } else if (busIndexMap.has(mapKey)) {
          const existingBusDatePayload = busIndexMap.get(mapKey).payload;
          if (Object.hasOwn(existingBusDatePayload, contractTypeKey)) {
            // Entries with same bus number, date, and contract type are found : Error
            duplicateContractErrorStr = displayDuplicateContractError(
              duplicateContractErrorStr,
              busNumberTrimmed,
              convertedDate,
              contractType,
              rowNo,
            );
          } else {
            // Entries with same bus number and date are found,
            //  but contract type is different : Allowed
            existingBusDatePayload[contractTypeKey] = amount;
          }
        } else {
          busIndexMap.set(mapKey, {
            index: count,
            payload: { busNumber: busNumberTrimmed, date: convertedDate },
          });
          const busDatePayload = busIndexMap.get(mapKey).payload;
          busDatePayload[contractTypeKey] = amount;
          // eslint-disable-next-line no-plusplus
          count++;
        }
      });
    const payloadArr = new Array(count);
    busIndexMap.forEach((value, key) => {
      const currentValue = busIndexMap.get(key);
      payloadArr[currentValue.index] = currentValue.payload;
    });
    this.handleDuplicateContractError(duplicateContractErrorStr, dataErrorInFile);
    const payload = {};
    payload.bulkContractEditSheetData = payloadArr;
    this.performConditionalUploadSheetAction(
      dataErrorInFile,
      duplicateContractErrorStr,
      uploadSheetAction,
      payload,
      initiateNotification,
    );
  };

  closeErrorAction = () => {
    const { messageCallBack, uploadSheetErrorAction, uploadType } = this.props;
    messageCallBack(null, null);
    uploadSheetErrorAction("", uploadType);
  };

  handleClick = () => {
    const { uploadType, addOnFilter } = this.props;
    if (uploadType === "grossContribution") {
      return this.handleBulkGCEditSubmission;
    }
    if (uploadType === "settlement") {
      return () => this.handleSheetSubmission({ type: "settlement" });
    }
    if (uploadType === "distance") {
      return () => this.handleSheetSubmission({
        type: "distance",
        addOnFilter,
      });
    }
    if (uploadType === "passRevenue") {
      return () => this.handleSheetSubmission({ type: "passRevenue" });
    }
    if (uploadType === "expense") {
      return () => this.handleSheetSubmission({ type: "expense" });
    }
    if (uploadType === "ondcReport") {
      return () => this.handleSheetSubmission({ type: "ondcReport" });
    }
    return this.handleSubmission;
  };

  // eslint-disable-next-line class-methods-use-this
  performConditionalUploadSheetAction(
    dataErrorInFile,
    duplicateContractErrorStr,
    uploadSheetAction,
    payload,
    initiateNotification,
  ) {
    if (
      (dataErrorInFile === ""
        || dataErrorInFile.length === 0)
      && duplicateContractErrorStr.length === 0
    ) {
      uploadSheetAction(payload, "fileLoader");
    } else {
      initiateNotification(
        MessageType.ERROR,
        "Gross Contribution Edit Failed",
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  isErrorInFormFields(
    busNumberTrimmed,
    convertedDate,
    contractType,
    contractTypeKey,
    amount,
  ) {
    return (!busNumberTrimmed?.length
      || Number.isNaN(amount)
      || (!amount && amount !== 0)
      || !contractType
      || !contractTypeKey
      || convertedDate.length !== 10
    );
  }

  render() {
    const {
      showModal,
      messageCallBack,
      fileLoader,
      settlementUploadSheetFail,
      grossContributionUploadSheetFail,
      distanceUploadSheetFail,
      passRevenueUploadSheetFail,
      expenseUploadSheetFail,
      ondcReportUploadSheetFail,
      isUploadDisabled,
      uploadType,
    } = this.props;
    const { dataErrorInFile } = this.state;
    const file = this.fileInputRef.current;

    return (
      <Dialog
        onClose={this.closeErrorAction}
        aria-labelledby="customized-dialog-title"
        open={showModal}
        className="excel-dialog-wrapper position-relative"
      >
        <DialogTitle
          data-testid="upload-modal-dialog-title"
          id="customized-dialog-title"
          onClose={() => messageCallBack(null, null)}
        >
          <div className="modal-header-wrapper">
            <div className="dialogTitle">Upload File</div>
            <div
              className="close-icon"
              role="button"
              onClick={this.closeErrorAction}
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.code === "27") {
                  this.closeDetailModal();
                }
              }}
              aria-label="close"
            >
              <CloseIcon />
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers className="excel-modal-body">
          {fileLoader === 1 && (
            <>
              <GenericLoaderComponent absolute />
              <div className="center-align info-label">
                Please do not close the window while we are processing the data.
              </div>
            </>
          )}
          {fileLoader !== 1 && (
            <form encType="multipart/form-data">
              <input
                type="file"
                accept={
                  uploadType === "ondcReport"
                    ? ".csv"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
                style={{ display: "none" }}
                onChange={this.changeHandler}
                ref={this.fileInputRef}
                id="contained-button-file"
              />
              <label
                htmlFor="contained-button-file"
                className="settlement-browse-button"
                aria-label="browse"
              >
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  buttonText="Browse"
                  onClick={() => { this.fileInputRef.current.value = ""; }}
                />
              </label>
              <div className="center-align">
                <i className="info-label">
                  [Allowed File Format:
                  {" "}
                  {uploadType === "ondcReport" ? ".csv" : ".xlsx"}
                  ]
                </i>
              </div>
              {file && file.files && file.files[0] && (
                <div className="file-content">{file.files[0].name}</div>
              )}
              {dataErrorInFile && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {dataErrorInFile.split("<br/>").join("\n")}
                </div>
              )}
              {settlementUploadSheetFail && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {settlementUploadSheetFail}
                </div>
              )}
              {grossContributionUploadSheetFail && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {grossContributionUploadSheetFail
                    .split(",")
                    .join("\n")}
                </div>
              )}
              {distanceUploadSheetFail && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {distanceUploadSheetFail.split(",").join("\n")}
                </div>
              )}
              {passRevenueUploadSheetFail && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {passRevenueUploadSheetFail.split(",").join("\n")}
                </div>
              )}
              {expenseUploadSheetFail && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {expenseUploadSheetFail.split(",").join("\n")}
                </div>
              )}
              {ondcReportUploadSheetFail && (
                <div
                  className="error-button"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {ondcReportUploadSheetFail.split(",").join("\n")}
                </div>
              )}
            </form>
          )}
        </DialogContent>
        <DialogActions className="footer-buttons">
          <Button
            classname="backBtnContainer settlement-upload-action-button"
            onClick={this.closeErrorAction}
            buttonText="Cancel"
          />
          <Button
            classname="settlement-upload-action-button button-container"
            disable={
              !(file && file.files && file.files[0])
              || isUploadDisabled
            }
            onClick={this.handleClick()}
            buttonText="Done"
          />
        </DialogActions>
      </Dialog>
    );
  }
}

UploadExcelModal.defaultProps = {
  showModal: false,
};

UploadExcelModal.propTypes = {
  showModal: PropTypes.bool,
  messageCallBack: PropTypes.func,
  isUploadDisabled: PropTypes.bool,
  uploadType: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    fileLoader: state && state.loadingBar && state.loadingBar.fileLoader,
    settlementUploadSheet: state.Settlement.settlementUploadSheet,
    settlementUploadSheetFail: state.Settlement.settlementUploadSheetError,
    distanceUploadSheetFail: state.Report.distanceUploadSheetError,
    passRevenueUploadSheetFail: state.PassRevenue.passRevenueUploadSheetError,
    expenseUploadSheetFail: state.Expenses.expenseUploadSheetError,
    grossContributionUploadSheetFail:
      state.Collection.grossContributionUploadSheetError,
    ondcReportUploadSheetFail:
      state.OndcReportUpload.ondcReportUploadSheetError,
  };
}

const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (type, message) => {
    dispatch(setNotificationMessage({ type, message }));
  },
  uploadSheetAction: (data, loaderScope, type) => {
    if (type === "settlement") {
      dispatch(settlementUploadSheetAction(data, loaderScope));
    } else if (type === "distance") {
      dispatch(uploadExcelFileAction(data, loaderScope));
    } else if (type === "passRevenue") {
      dispatch(passRevenueUploadExcelFileAction(data, loaderScope));
    } else if (type === "expense") {
      dispatch(expenseUploadExcelFileAction(data, loaderScope));
    } else if (type === "ondcReport") {
      dispatch(ondcReportAction(data, loaderScope));
    } else {
      // gross contribution case
      dispatch(grossContributionUploadSheetAction(data, loaderScope));
    }
  },
  uploadSheetErrorAction: (data, type) => {
    // dispatch(settlementUploadSheetFailure(data));
    if (type === "settlement") {
      dispatch(settlementUploadSheetFailure(data));
    } else if (type === "distance") {
      dispatch(distanceUploadSheetFailure(data));
    } else if (type === "passRevenue") {
      dispatch(passRevenueUploadSheetFailure(data));
    } else if (type === "expense") {
      dispatch(expenseUploadSheetFailure(data));
    } else if (type === "ondcReport") {
      dispatch(ondcReportUploadFailure(data));
    } else {
      // gross contribution case
      dispatch(grossContributionUploadSheetFailure(data));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadExcelModal);
